module.exports = __webpack_public_path__ + "img/l1.2a73870.svg";